// ─── Ornament Library ─────────────────────────────────────────
// Curated SVG ornaments for wedding/event invitations.
// All use currentColor for tintability.

export const ORNAMENT_CATEGORIES = [
  { id: 'flourishes', label: 'Flourishes' },
  { id: 'laurels', label: 'Laurels' },
  { id: 'lines', label: 'Lines' },
  { id: 'symbols', label: 'Symbols' },
];

export const ORNAMENTS = [
  // ─── Flourishes ────────────────────────────────
  {
    id: 'flourish-classic',
    name: 'Classic Flourish',
    category: 'flourishes',
    viewBox: '0 0 240 50',
    svg: `<path d="M20 25 C40 5, 60 5, 80 25 C100 45, 120 45, 120 25 C120 5, 140 5, 160 25 C180 45, 200 45, 220 25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>`,
  },
  {
    id: 'flourish-scroll',
    name: 'Scroll Flourish',
    category: 'flourishes',
    viewBox: '0 0 260 60',
    svg: `<path d="M30 30 C30 10, 50 10, 50 25 C50 35, 40 40, 30 30" fill="none" stroke="currentColor" stroke-width="1.2"/><line x1="45" y1="30" x2="215" y2="30" stroke="currentColor" stroke-width="1"/><path d="M230 30 C230 10, 210 10, 210 25 C210 35, 220 40, 230 30" fill="none" stroke="currentColor" stroke-width="1.2"/>`,
  },
  {
    id: 'flourish-elegant',
    name: 'Elegant Swirl',
    category: 'flourishes',
    viewBox: '0 0 200 40',
    svg: `<path d="M10 20 Q30 0, 60 15 T100 20 T140 25 T190 20" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="100" cy="20" r="2.5" fill="currentColor"/>`,
  },
  {
    id: 'flourish-wings',
    name: 'Wing Flourish',
    category: 'flourishes',
    viewBox: '0 0 240 50',
    svg: `<path d="M120 25 C100 10, 60 5, 20 20 C40 15, 80 10, 110 25" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M120 25 C140 10, 180 5, 220 20 C200 15, 160 10, 130 25" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="120" cy="25" r="3" fill="currentColor"/>`,
  },

  // ─── Laurels ───────────────────────────────────
  {
    id: 'laurel-simple',
    name: 'Simple Laurel',
    category: 'laurels',
    viewBox: '0 0 200 80',
    svg: `<path d="M90 70 C80 55, 60 50, 50 40 C45 35, 50 25, 60 30 C65 32, 63 38, 58 36" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M90 70 C85 50, 70 40, 55 25 C50 20, 55 12, 65 18 C70 22, 65 28, 60 25" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M90 70 C90 45, 80 30, 75 15 C72 8, 80 5, 85 12 C88 18, 82 22, 78 18" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M110 70 C120 55, 140 50, 150 40 C155 35, 150 25, 140 30 C135 32, 137 38, 142 36" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M110 70 C115 50, 130 40, 145 25 C150 20, 145 12, 135 18 C130 22, 135 28, 140 25" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M110 70 C110 45, 120 30, 125 15 C128 8, 120 5, 115 12 C112 18, 118 22, 122 18" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>`,
  },
  {
    id: 'laurel-branch',
    name: 'Branch',
    category: 'laurels',
    viewBox: '0 0 200 40',
    svg: `<line x1="20" y1="20" x2="180" y2="20" stroke="currentColor" stroke-width="0.8"/><path d="M40 20 C35 10, 25 8, 20 12" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M60 20 C55 10, 45 8, 40 12" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M80 20 C75 10, 65 8, 60 12" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M120 20 C125 10, 135 8, 140 12" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M140 20 C145 10, 155 8, 160 12" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M160 20 C165 10, 175 8, 180 12" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>`,
  },
  {
    id: 'laurel-wreath',
    name: 'Wreath',
    category: 'laurels',
    viewBox: '0 0 100 100',
    svg: `<path d="M50 90 C30 80, 15 65, 12 45 C10 30, 18 15, 35 10 C42 8, 48 10, 50 15" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M50 90 C70 80, 85 65, 88 45 C90 30, 82 15, 65 10 C58 8, 52 10, 50 15" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M30 70 C25 60, 22 48, 25 38" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round"/><path d="M70 70 C75 60, 78 48, 75 38" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round"/>`,
  },

  // ─── Lines / Dividers ──────────────────────────
  {
    id: 'line-dots',
    name: 'Dot Line',
    category: 'lines',
    viewBox: '0 0 200 10',
    svg: `${Array.from({length: 15}, (_, i) => `<circle cx="${14 + i * 12.5}" cy="5" r="1.5" fill="currentColor"/>`).join('')}`,
  },
  {
    id: 'line-diamonds',
    name: 'Diamond Line',
    category: 'lines',
    viewBox: '0 0 200 14',
    svg: `<line x1="10" y1="7" x2="80" y2="7" stroke="currentColor" stroke-width="0.8"/><polygon points="95,1 100,7 95,13 90,7" fill="currentColor"/><polygon points="105,1 110,7 105,13 100,7" fill="currentColor"/><line x1="120" y1="7" x2="190" y2="7" stroke="currentColor" stroke-width="0.8"/>`,
  },
  {
    id: 'line-wave',
    name: 'Wave',
    category: 'lines',
    viewBox: '0 0 200 20',
    svg: `<path d="M10 10 Q30 0, 50 10 Q70 20, 90 10 Q110 0, 130 10 Q150 20, 170 10 Q190 0, 200 10" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>`,
  },
  {
    id: 'line-arrows',
    name: 'Arrow Line',
    category: 'lines',
    viewBox: '0 0 200 14',
    svg: `<line x1="30" y1="7" x2="170" y2="7" stroke="currentColor" stroke-width="0.8"/><path d="M10 7 L25 2 L25 12 Z" fill="currentColor"/><path d="M190 7 L175 2 L175 12 Z" fill="currentColor"/>`,
  },

  // ─── Symbols ───────────────────────────────────
  {
    id: 'symbol-heart',
    name: 'Heart',
    category: 'symbols',
    viewBox: '0 0 60 55',
    svg: `<path d="M30 50 C10 35, 0 20, 5 12 C10 4, 20 4, 25 10 L30 18 L35 10 C40 4, 50 4, 55 12 C60 20, 50 35, 30 50Z" fill="currentColor" opacity="0.9"/>`,
  },
  {
    id: 'symbol-ampersand',
    name: 'Ampersand',
    category: 'symbols',
    viewBox: '0 0 60 70',
    svg: `<text x="50%" y="55" text-anchor="middle" font-family="'Playfair Display', Georgia, serif" font-size="60" fill="currentColor">&amp;</text>`,
  },
  {
    id: 'symbol-rings',
    name: 'Rings',
    category: 'symbols',
    viewBox: '0 0 80 50',
    svg: `<circle cx="28" cy="25" r="16" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="52" cy="25" r="16" fill="none" stroke="currentColor" stroke-width="1.5"/>`,
  },
  {
    id: 'symbol-star',
    name: 'Star',
    category: 'symbols',
    viewBox: '0 0 50 50',
    svg: `<polygon points="25,2 31,18 48,18 34,29 39,46 25,36 11,46 16,29 2,18 19,18" fill="currentColor"/>`,
  },
  {
    id: 'symbol-cross',
    name: 'Cross',
    category: 'symbols',
    viewBox: '0 0 40 40',
    svg: `<line x1="20" y1="5" x2="20" y2="35" stroke="currentColor" stroke-width="1.2"/><line x1="5" y1="20" x2="35" y2="20" stroke="currentColor" stroke-width="1.2"/>`,
  },
];
